module.exports = __webpack_public_path__ + "static/media/duty.4d622200.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/duty.PNG
// module id = 564
// module chunks = 0